import { FC, useState } from "react";
import {
  Banner,
  ButtonWO,
  Input,
  PageContainer,
  PageWrapper,
  Paragraph,
  SubHeading,
  ErrorText,
} from "../shared.styled";
import logo from "../../assets/images/logo.svg";
import { useParams } from "react-router-dom";
import { patch, post } from "../../api/api";
import { useNavigate } from "react-router-dom";

const PickPassword: FC = (): JSX.Element => {
  const [password, setPassword] = useState<string>("");
  const [error, setError] = useState<string>("");
  const { deviceId } = useParams();
  const navigate = useNavigate();

  const handleSubmit = async () => {
    try {
      const deviceResp = await patch(`/device/password/${deviceId}`, {
        password,
        deviceId,
      });
      if (deviceResp) {
        const authResp = await post("/auth/login", { password, deviceId });
        localStorage.setItem("token", authResp.data.token);
        navigate("/setup");
      } else {
        setError("Oh dear.. something went wrong. Please try again.");
      }
    } catch (error) {
      setError(
        "This device is already activated. If you need to reset your password please reset the devive and retry setup."
      );
    }
  };

  return (
    <PageWrapper>
      <PageContainer style={{ textAlign: "center" }}>
        <Banner>
          <img src={logo} alt="logo" width="260" />
        </Banner>
        <SubHeading>Select a password</SubHeading>
        <Paragraph>
          You'll use this to login to your account and change the sites your
          device forecasts for.
        </Paragraph>
        {error && <ErrorText>{error}</ErrorText>}
        <Input
          placeholder="Password"
          type="password"
          onChange={(e) => setPassword(e.target.value)}
        />
        <ButtonWO onClick={handleSubmit}>Submit</ButtonWO>
      </PageContainer>
    </PageWrapper>
  );
};

export default PickPassword;
